// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_hd-3";
export var flatBottomCorners = "_hd-5";
export var productImage = "_hd-0";
export var quantityContainer = "_hd-2";
export var quantityHeader = "_hd-6";
export var tooltip = "_hd-1";
export var wrapAndEllipsesOverflow = "_hd-4";